import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
const DefaultCarousel = ({
  children,
  bannerModifier,
  itemsPerRow,
  enableAutoScroll,
  autoScrollTimer,
  pauseScrollOnHover,
  modifier
}) => {
  const ref = useRef();
  const [buttonDisplay, setButtonDisplays] = useState({
    displayLeft: false,
    displayRight: true
  });
  const [shouldAutoScroll, setShouldAutoScroll] = useState(false);
  const autoScrollRef = useRef();
  useEffect(() => {
    autoScrollRef.current = shouldAutoScroll;
    const id = setInterval(scrollCheck, autoScrollTimer);
    function scrollCheck() {
      if (!autoScrollRef.current) {
        clearInterval(id);
      } else {
        handleButtonNavigation(true);
      }
    }
    return () => clearInterval(id);
  }, [autoScrollTimer, shouldAutoScroll]);
  useEffect(() => {
    const {
      current: {
        offsetWidth,
        scrollWidth
      }
    } = ref;
    if (scrollWidth <= offsetWidth) {
      setButtonDisplays({
        displayLeft: false,
        displayRight: false
      });
    }
    setShouldAutoScroll(enableAutoScroll);
  }, [enableAutoScroll]);
  const handleScroll = () => {
    const {
      current: {
        offsetWidth,
        scrollLeft,
        scrollWidth
      }
    } = ref;
    const updatedDisplayLeft = !!scrollLeft;
    const updatedDisplayRight = scrollLeft + offsetWidth + 1 < scrollWidth;
    setButtonDisplays({
      displayLeft: updatedDisplayLeft,
      displayRight: updatedDisplayRight
    });
  };
  const handleMouseEnter = () => {
    if (pauseScrollOnHover) setShouldAutoScroll(false);
  };
  const handleMouseLeave = () => {
    if (pauseScrollOnHover) setShouldAutoScroll(true);
  };
  const handleButtonNavigation = direction => {
    if (!ref || !ref.current) return;
    const {
      current: {
        offsetWidth,
        scrollLeft,
        scrollWidth
      }
    } = ref;
    if (autoScrollRef.current && scrollLeft + offsetWidth >= scrollWidth) {
      ref.current.scrollLeft = 0;
    } else {
      ref.current.scrollLeft = direction ? scrollLeft + offsetWidth : scrollLeft - offsetWidth;
    }
  };
  const {
    displayLeft,
    displayRight
  } = buttonDisplay;
  const parsedModifier = modifier ? ` ${modifier}` : '';
  const wrapperClassName = `cards-carousel${bannerModifier}${parsedModifier}`;
  const contentClassName = `cards-carousel--content items-per-row-${itemsPerRow}`;
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards-carousel--left-button-wrapper"
  }, displayLeft && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cards-carousel--button-back icon-button icon",
    onClick: () => {
      setShouldAutoScroll(false);
      handleButtonNavigation();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "cards-carousel--arrow cards-carousel--arrow__left"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cards-carousel--right-button-wrapper"
  }, displayRight && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cards-carousel--button-forward icon-button icon",
    onClick: () => {
      setShouldAutoScroll(false);
      handleButtonNavigation(true);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "cards-carousel--arrow cards-carousel--arrow__right"
  }))), /*#__PURE__*/React.createElement("div", {
    className: contentClassName,
    ref: ref,
    onScroll: handleScroll
  }, children));
};
DefaultCarousel.propTypes = {
  bannerModifier: PropTypes.string,
  itemsPerRow: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  enableAutoScroll: PropTypes.bool,
  pauseScrollOnHover: PropTypes.bool,
  autoScrollTimer: PropTypes.number
};
DefaultCarousel.defaultProps = {
  itemsPerRow: 0,
  bannerModifier: '',
  children: [],
  enableAutoScroll: false,
  pauseScrollOnHover: false,
  autoScrollTimer: 0
};
export default DefaultCarousel;
//# sourceMappingURL=DefaultCarousel.js.map